import React,{useContext,useState} from "react";
import { HotelOwnerContext } from "./HotelOwnerContext";
import { Link,Outlet } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTachometerAlt,faSignOut, faUser} from '@fortawesome/free-solid-svg-icons';
import "./hotelOwnerHotels.css"
export default function HotelOwnerDashboard() {
const {hotelOnwerData}=useContext(HotelOwnerContext)

const [dropdownVisible,setDropDownVisible]=useState(false)
    return (
      <div className="bg-gray-100 flex flex-col justify-between landing-page mt-20">
        <div className=" hover:text-blue-500 flex flex-col mx-4" onMouseEnter={()=>setDropDownVisible(true)} onMouseLeave={()=>setDropDownVisible(false)}>
          <Link to="account" className=" hover:text-blue-500 flex flex-col">
          {hotelOnwerData?.profile?<img src={hotelOnwerData?.profile} alt={hotelOnwerData?.username} className=" w-12 h-12 rounded-full"/>:<FontAwesomeIcon icon={faUser} className=" w-12 h-12 rounded-full mt-2"/>}
          </Link>
         
          {dropdownVisible && 
               <div className="top-20 left-0 bg-white shadow-lg rounded-md p-4 w-40  gap-x-6">
                 <Link to="account/change" className="block text-gray-700 hover:text-blue-500 mb-2">
                    <FontAwesomeIcon icon={faTachometerAlt}/>Account
                 </Link>

                 <Link to="account/logout" className="block text-gray-700 hover:text-blue-500 mb-2">
                    <FontAwesomeIcon icon={faSignOut}/>Logout
                 </Link>
               </div>
            }
                  </div>
        <div className=" ml-2">
          <p>Welcome {hotelOnwerData?.username}</p> 
          <section className=" flex flex-row space-x-4">
          <Link to="hotels" className=" ">Hotels</Link>  
          <Link to="/hotelOwnerDash/communicate">Communicate</Link>
            </section>     
          
          <Outlet/>
        </div>
      </div>
      
    );
}

